import { Outlet } from "react-router";
import "./App.css";
import Navbar from "./components/header/Navbar";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <div
      className=""
      style={{
        backgroundImage: "url(background.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        textAlign: "center",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <header>
        <Navbar></Navbar>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}

export default App;
